import React from 'react';
import {
  Button,
  SvgExternalLink,
  Stack,
  Copy,
  Flex,
  Tooltip,
  IButtonProps,
  Box,
} from '@grubhubprod/gh-cookbook-react';
import { buildBalancePortalUrl } from 'src/components/selfService/common/Balance/utils/buildBalancePortalUrl';
import { BalancePortalPage } from 'src/components/selfService/common/Balance/balance.types';
import { useBalanceContext } from 'src/components/selfService/common/Balance/hooks/useBalanceContext';

interface BalancePortalButtonProps extends IButtonProps {
  balancePortalPage: BalancePortalPage;
  text: string;
  unavailablePortalTooltipText?: string;
  fullWidth?: boolean;
}

export function BalancePortalButton({
  balancePortalPage,
  text,
  unavailablePortalTooltipText,
  fullWidth,
  ...props
}: BalancePortalButtonProps): JSX.Element {
  const { portalUrl } = useBalanceContext();

  const balancePortalUrl = portalUrl?.portalUrl;
  const href = balancePortalUrl
    ? buildBalancePortalUrl(balancePortalUrl, balancePortalPage)
    : null;
  const isButtonDisabled = !href;

  return (
    <Box style={{ width: fullWidth ? '100%' : 'auto' }}>
      <Tooltip
        disable={!isButtonDisabled}
        alignment="middle"
        content={
          <Copy variant="body">
            {unavailablePortalTooltipText || 'Balance portal is not available'}
          </Copy>
        }
        position="below"
      >
        <Button
          variant="secondary"
          buttonSize="medium"
          target="_blank"
          as="a"
          href={href}
          disabled={isButtonDisabled}
          {...props}
        >
          <Flex alignItems="center" justifyContent="center" height="100%">
            <Stack x="x-sm" alignItems="center">
              {text}
            </Stack>
            <SvgExternalLink size="20px" />
          </Flex>
        </Button>
      </Tooltip>
    </Box>
  );
}
